import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserService } from '../services/user-service';

export const adminGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  return userService.user.value.isAdmin || userService.user.value.isReadOnly;
};
